import { motion } from "framer-motion";

import EmbedFrame from "@/components/EmbedFrame";
import SectionHeading from "@/components/SectionHeading";
import SmartLink from "@/components/SmartLink";
import { Button } from "@/components/ui/button";

export default function NewsletterSignupSection({ content, dataTestId, className = "" }) {
  return (
    <section className={`py-16 md:py-24 ${className}`.trim()} data-testid={dataTestId}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <SectionHeading
              title={content.title}
              description={content.description}
              align="left"
              className="mb-8"
            />
            {content.secondaryCta ? (
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" className="rounded-full bg-secondary hover:bg-secondary/85 text-white font-medium px-8 btn-hover">
                  <SmartLink href={content.secondaryCta.href} external={content.secondaryCta.external}>
                    {content.secondaryCta.label}
                  </SmartLink>
                </Button>
              </div>
            ) : null}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <EmbedFrame
              embedHtml={content.embed.embedHtml}
              embedUrl={content.embed.embedUrl}
              title={content.embed.title}
              placeholderLabel={content.embed.placeholderLabel}
              aspectRatio="form"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
